import React from 'react'
import { ButtonEditInline } from '../../../../../../Components/Buttons/ButtonEditInline'
import { ButtonArchiveInline } from '../../../../../../Components/Buttons/ButtonArchiveInline'
import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import * as CONST from '../../../../../../Reducers/Location/const'
import { LinkView } from '../../../../../../Components/Link/View'
import { getLocationProfileLink } from '../../../../../../Utils/Link'
import { styles } from './styles'
import { StatusLabel } from 'Components/StatusLabel'

const generateStatBlock = ({ value, diff, type }) => {
  const diffColor =
    diff === null || diff === 0
      ? 'rgba(0, 17, 43, 1)'
      : diff > 0
      ? 'rgba(19, 114, 100, 1)'
      : 'rgba(215, 43, 79, 1)'
  return value === null ? (
    <div style={styles.valueSmall}>N/A</div>
  ) : (
    <div style={styles.statBlock}>
      <div style={styles.value}>
        {`${value}${type == 'footTraffic' ? ' flyers/min' : '%'}`}
      </div>
      <div
        style={{
          fontSize: '12px',
          fontWeight: '400',
          color: diffColor,
        }}
      >{`(${diff > 0 ? '+' : ''}${diff ? `${diff}% ` : ''}${
        diff === null || diff === 0
          ? 'no changes from last week'
          : 'from last week'
      })`}</div>
    </div>
  )
}

const H2HLocationRow = ({
  location,
  handleModalArchiveShow,
  handleModalEditShow,
  cityId,
  isCityManagerAssistant,
}) => {
  const isArchived = location.status === CONST.LOCATION_STATUS[2].value
  return (
    <Tr key={`location-row-${location.id}`}>
      <Td>
        <div style={styles.valueSmall}>{location.name}</div>
      </Td>
      <Td>
        <div style={styles.valueSmall}>{location.type.name}</div>
      </Td>
      <Td>
        <div style={styles.valueSmall}>
          {location.statistics.deliveredFlyersNumber || '-'}
        </div>
      </Td>

      <Td className="no-opacity">
        {generateStatBlock({
          value: location.statistics.currentDeliveredFlyers,
          diff: location.statistics.deliveredFlyersDiffInPercentage,
          type: 'deliveredFlyer',
        })}
      </Td>
      <Td className="no-opacity">
        {generateStatBlock({
          value: location.statistics.currentFootTraffic,
          diff: location.statistics.footTrafficDiffInPercentage,
          type: 'footTraffic',
        })}
      </Td>
      <Td className="no-opacity">
        {generateStatBlock({
          value: location.statistics.currentScanRate,
          diff: location.statistics.scanRateDiffInPercentage,
          type: 'scanRate',
        })}
      </Td>
      <Td className="no-opacity">
        {generateStatBlock({
          value: location.statistics.currentConversionRate,
          diff: location.statistics.conversionRateDiffInPercentage,
          type: 'conversionRate',
        })}
      </Td>
      <Td className="no-opacity">
        <StatusLabel
          status={
            location.status === CONST.LOCATION_STATUS[2].value
              ? 'archived'
              : 'active'
          }
        />
      </Td>
      <Td className="align-right no-opacity">
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          {!isCityManagerAssistant ? (
            <LinkView
              className="link-view"
              onClick={() => {
                const url = getLocationProfileLink(cityId, location.id)
                window.open(url, '_blank').focus()
              }}
            />
          ) : null}
          <ButtonEditInline
            onClickHandler={() => handleModalEditShow(location)}
          />
          {!isArchived && (
            <ButtonArchiveInline
              onClickHandler={() => handleModalArchiveShow(location.id)}
              title="Archive location"
            />
          )}
        </div>
      </Td>
    </Tr>
  )
}

export default H2HLocationRow
